<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-dialog
    v-model="open_flg"
        width="950px"
>
    <v-card
        flat
        width="950px"
    >
        <v-toolbar
            flat
            color="#E11D31"
            height="50px"
            dark
        >
            <v-spacer />
            <v-icon
                @click="open_flg=false"
            >
                mdi-close
            </v-icon>
        </v-toolbar>
        <v-card-text class="mt-3">
            記事化候補記事の一覧を表示しています。対象プレスリリースの記事だったものにOKに設定するとQlipperのプロジェクト画面でリリースの効果を閲覧することができます。
        </v-card-text>
        <v-card-text>
            <v-list outlined max-height="500px" class="overflow-y-auto">
                <v-list-item v-for="item in itemlist" :key="item.doc_id">
                    <v-row>
                        <v-col cols="2">
                            <v-switch
                              v-model="item.status"
                              true-value="t"
                              false-value="f"
                              label="OK"
                              class="mt-0"
                              @change="dataupdate(item.doc_id,item.rel_doc_id,item.status)"
                            ></v-switch>
                        </v-col>
                        <v-col><a :href="decodeURIComponent(item.doc_url)" target="_blank">{{ item.doc_title }}</a></v-col>
                        <v-col cols="3">{{ item.media_title }}</v-col>
                    </v-row>
                </v-list-item>
            </v-list>
        </v-card-text>
    </v-card>
</v-dialog>
</template>
<script>
export default {
    data : function(){
        return {
            ok         : false,
            open_flg : false,
            itemlist : [],
        };
    },
    methods : {
        dataupdate : async function(doc_id,rel_doc_id,status){
            console.log(doc_id);
            console.log(rel_doc_id);
            console.log(status);
            var params = new URLSearchParams();
            params.append("rel_doc_id",rel_doc_id);
            params.append("doc_id",doc_id);
            params.append("status",status);
            await axios.post("/api/release/set_release_doc_status",params)
            .then(response => {
                this.itemlist = response.data;
            })
            .catch((error) => {
                console.error('失敗です', error);
            });
        
        },
        open : function(id){
            this.getlist(id);
        },
        getlist : async function(id){
            var params = new URLSearchParams();
            params.append("rel_doc_id",id);
            await axios.post("/api/release/get_release_doc_data",params)
            .then(response => {
                this.itemlist = response.data;
                this.open_flg=true;
            })
            .catch((error) => {
                console.error('失敗です', error);
            });
        },
    }
}
</script>
